module.exports = __webpack_public_path__ + "img/p_sz_13.37b155e9.svg";